/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Correction_PlaceholderInputs */

const en_dialog_correction_placeholder = /** @type {(inputs: Dialog_Correction_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the correction for the excerpt here`)
};

const es_dialog_correction_placeholder = /** @type {(inputs: Dialog_Correction_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa la corrección del extracto aquí`)
};

/**
* | output |
* | --- |
* | "Enter the correction for the excerpt here" |
*
* @param {Dialog_Correction_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_correction_placeholder = /** @type {((inputs?: Dialog_Correction_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Correction_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_correction_placeholder(inputs)
	return en_dialog_correction_placeholder(inputs)
});